import React from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  ConfirmationNumber as TicketIcon,
  FitnessCenter as FitnessCenterIcon,
} from "@mui/icons-material";

const PopularStatistics = ({ dashboardData, formatCurrency }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!dashboardData) {
    return (
      <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
        Brak danych do wyświetlenia
      </Typography>
    );
  }

  return (
    <>
      {/* Popular Pass Types */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, display: 'flex', alignItems: 'center' }}>
          <TicketIcon sx={{ mr: 1 }} />
          Popularne typy karnetów
        </Typography>
        <TableContainer>
          <Table size={isMobile ? "small" : "medium"}>
            <TableHead>
              <TableRow>
                <TableCell>Typ karnetu</TableCell>
                <TableCell align="right">Liczba sprzedanych</TableCell>
                <TableCell align="right">Przychód</TableCell>
                <TableCell align="right">Średnia cena</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dashboardData.popular_pass_types && dashboardData.popular_pass_types.length > 0 ? (
                dashboardData.popular_pass_types.map((passType, index) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {passType.pass_type_name}
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography variant="body2">{passType.count}</Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography variant="body2" sx={{ fontWeight: 600, color: '#4facfe' }}>
                        {formatCurrency(passType.revenue)}
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography variant="body2">
                        {formatCurrency(passType.revenue / passType.count)}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <Typography variant="body2" color="text.secondary">
                      Brak danych
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Popular Lesson Types */}
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, display: 'flex', alignItems: 'center' }}>
          <FitnessCenterIcon sx={{ mr: 1 }} />
          Popularne zajęcia
        </Typography>
        <TableContainer>
          <Table size={isMobile ? "small" : "medium"}>
            <TableHead>
              <TableRow>
                <TableCell>Typ zajęć</TableCell>
                <TableCell align="right">Liczba uczestników</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dashboardData.popular_lesson_types && dashboardData.popular_lesson_types.length > 0 ? (
                dashboardData.popular_lesson_types.map((lessonType, index) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {lessonType.lesson_type_name}
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography variant="body2" sx={{ fontWeight: 600, color: '#f093fb' }}>
                        {lessonType.count}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={2} align="center">
                    <Typography variant="body2" color="text.secondary">
                      Brak danych
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
};

export default PopularStatistics;
